export const DBKey = {    
  'DBName':'PremiumDB',
  DBSearchDetail: {
    'StoreName': 'search_suggestion',
    'SchemaName1': 'SuggestionText',
    'SchemaName2': 'SuggestionData'
  }
  }; 

export const DBConfig = {
    name: DBKey.DBName,
    version: 2,
    objectStoresMeta: [
      {
        store: DBKey.DBSearchDetail.StoreName,
        storeConfig: { keyPath: "id", autoIncrement: true },
        storeSchema: [
          { name: DBKey.DBSearchDetail.SchemaName1, keypath: DBKey.DBSearchDetail.SchemaName1, options: { unique: false } },
          { name: DBKey.DBSearchDetail.SchemaName2, keypath: DBKey.DBSearchDetail.SchemaName2, options: { unique: false } },
        ],
      },
    ],
  };
